/**
 * Utility functions for managing trial extension deeplink data in localStorage.
 * Used to persist the intent when a different user is currently logged in.
 */

const PENDING_TRIAL_EXTENSION_ACCOUNT_ID_KEY = 'pendingTrialExtensionAccountId'
const PENDING_TRIAL_EXTENSION_TIMESTAMP_KEY = 'pendingTrialExtensionTimestamp'

export function setPendingTrialExtension(accountId: string): void {
	try {
		localStorage.setItem(PENDING_TRIAL_EXTENSION_ACCOUNT_ID_KEY, accountId)
		localStorage.setItem(
			PENDING_TRIAL_EXTENSION_TIMESTAMP_KEY,
			Date.now().toString()
		)
	} catch (e) {
		console.error(
			'Error storing pending trial extension in localStorage:',
			e
		)
	}
}

export function getPendingTrialExtension(): string | null {
	try {
		return localStorage.getItem(PENDING_TRIAL_EXTENSION_ACCOUNT_ID_KEY)
	} catch (e) {
		console.error(
			'Error reading pending trial extension from localStorage:',
			e
		)
		return null
	}
}

export function clearPendingTrialExtension(): void {
	try {
		localStorage.removeItem(PENDING_TRIAL_EXTENSION_ACCOUNT_ID_KEY)
		localStorage.removeItem(PENDING_TRIAL_EXTENSION_TIMESTAMP_KEY)
	} catch (e) {
		console.error(
			'Error clearing pending trial extension from localStorage:',
			e
		)
	}
}

export function clearStalePendingTrialExtension(
	maxAge: number = 60 * 60 * 1000
): void {
	try {
		const timestamp = localStorage.getItem(
			PENDING_TRIAL_EXTENSION_TIMESTAMP_KEY
		)
		if (timestamp) {
			const age = Date.now() - parseInt(timestamp, 10)
			if (age > maxAge) {
				clearPendingTrialExtension()
			}
		}
	} catch (e) {
		console.error('Error clearing stale trial extension from localStorage:', e)
	}
}
